import { ComponentProps } from "react";
import Card from "@particles/card/Card";
import {
  LeadCardVariations,
  SubCardVariationsWithImages,
  SubCardVariationsWithoutImages,
} from "@particles/card/templates/TemplateA/utils/contants";
import { SanitizedFeedSectionArticle } from "@typings/Cue";
import { getUrlQuery } from "@util/helpers";
import { startCase, toLower } from "lodash-es";

/**
 * Returns the card variations based on the index for the Global page.
 * The first card is a LeadCard, the second and third cards are SubCards with images,
 * and all subsequent cards are SubCards without images.
 * This is used to render the International and Singapore Section
 */
export const getCardVariations = (index: number) => {
  switch (index) {
    case 0:
      return LeadCardVariations;

    case 1:
    case 2:
      return SubCardVariationsWithImages;

    default:
      return SubCardVariationsWithoutImages;
  }
};

/**
 * Returns the card props for the Template A component.
 * @param articles - The articles to be displayed in the component.
 * @param ref - The reference to be used for the link.
 * @returns {ComponentProps<typeof Card>[]} - The card props for the Template A component.
 */
export const getTemplateAProps = (
  articles: SanitizedFeedSectionArticle[],
  ref: string
): ComponentProps<typeof Card>[] => {
  const linkParams = new URLSearchParams({ ref });

  return articles.map(({ id, title, urlPath, media, blurb, kicker }, index) => {
    const leadArticle = index === 0;
    const hasImage = [1, 2].includes(index) || leadArticle;
    const _media = hasImage ? media[0] : undefined;
    const _kicker = leadArticle ? kicker : undefined;
    const defaultImage = hasImage ? { directoryName: "global" } : undefined;
    const _blurb = hasImage ? blurb : undefined;

    const props: ComponentProps<typeof Card> = {
      id,
      link: urlPath + getUrlQuery(urlPath, linkParams),
      title,
      media: _media,
      defaultImage,
      blurb: _blurb,
      kicker: startCase(toLower(_kicker?.fields?.[0]?.value)),
    };

    return props;
  });
};
